// R7.2: tijdstippen altijd in Europe/Amsterdam als dd-mm-jjjj HH:mm.
const FMT = new Intl.DateTimeFormat('nl-NL', {
  timeZone: 'Europe/Amsterdam', day: '2-digit', month: '2-digit', year: 'numeric',
  hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});
const FMT_DAG = new Intl.DateTimeFormat('nl-NL', {
  timeZone: 'Europe/Amsterdam', day: '2-digit', month: '2-digit', year: 'numeric',
});

const delen = (fmt, iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return Object.fromEntries(fmt.formatToParts(d).map(p => [p.type, p.value]));
};

export const fmtDatumTijd = (iso) => {
  const p = delen(FMT, iso);
  return p ? `${p.day}-${p.month}-${p.year} ${p.hour}:${p.minute}` : '';
};

export const fmtDatum = (iso) => {
  const p = delen(FMT_DAG, iso);
  return p ? `${p.day}-${p.month}-${p.year}` : '';
};

// Meldmoment van de server; oude meldingen zonder tijdstip tonen hun datum.
export const fmtGemeldOp = (gemeldOp, datum) =>
  (gemeldOp ? fmtDatumTijd(gemeldOp) : fmtDatum(datum)) || '-';
